import React from 'react';
import { Textarea } from '../ui/textarea';
import { FileText, Mic } from 'lucide-react';

const FORM_SECTIONS = [
  { key: 'info_arrivo', label: "Informazioni e Situazione all'Arrivo sul Posto" },
  { key: 'provvedimenti', label: 'In Considerazione di Quanto Sopra si Provvedeva A' },
  { key: 'risultati_ottenuti', label: 'Risultati Ottenuti' },
  { key: 'danni', label: 'Danni a Persone, Beni, Risorse Ambientali o Naturali' },
  { key: 'persone_infortunate', label: 'Persone Infortunate e/o Decedute' },
  { key: 'causa_sinistro', label: 'Presumibile Causa del Sinistro' },
  { key: 'provvedimenti_tutela', label: 'Provvedimenti di Tutela Adottati' },
  { key: 'attivita_polizia', label: 'Attività di Polizia Giudiziaria' },
  { key: 'info_precedenti', label: 'Informazioni Importate dalla Precedente Versione di STAT-RI' },
];

export const FormSectionsBlock = ({ intervention, onChange }) => (
  <>
    {FORM_SECTIONS.map((section) => (
      <div key={section.key} className="form-section pl-8">
        <h3 className="text-lg font-semibold uppercase mb-4 flex items-center gap-3" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
          <FileText className="w-5 h-5 text-[#E3000F]" />
          {section.label}
        </h3>
        {intervention[section.key]?.includes('[Trascrizione vocale]') && (
          <span className="provenance-badge transcribed mb-2 inline-flex">
            <Mic className="w-3 h-3 mr-1" />
            Trascritto da audio
          </span>
        )}
        <Textarea
          value={intervention[section.key] || ''}
          onChange={(e) => onChange(section.key, e.target.value)}
          className="bg-[#0A0A0A] border-[#27272A] rounded-none text-white min-h-[120px]"
          placeholder={`Inserisci ${section.label.toLowerCase()}...`}
          data-testid={`input-${section.key}`}
        />
      </div>
    ))}
  </>
);
